import { Fraction } from 'bi-fraction';
import { BONDING_K, BONDING_SUPPLY, FUN_TOKEN_DECIMALS } from '../constants';
export function getInitialSupplyReceiveAmount(purchaseAmount, assetRate) {
    const k = (BONDING_K * 10000n) / assetRate;
    const liquidity = (((k * 10000n * 10n ** BigInt(FUN_TOKEN_DECIMALS)) / BONDING_SUPPLY) *
        10n ** BigInt(FUN_TOKEN_DECIMALS)) /
        10000n;
    const initialAmount = BigInt(purchaseAmount.shl(FUN_TOKEN_DECIMALS).quotient);
    const fee = initialAmount / 100n;
    const purchaseAmountAfterFee = initialAmount - fee;
    const amountOut = (BONDING_SUPPLY * purchaseAmountAfterFee) /
        (liquidity + purchaseAmountAfterFee);
    return new Fraction(amountOut + 1n).shr(FUN_TOKEN_DECIMALS);
}
